<template>
    <v-dialog v-model="show" scrollable max-width="500">
        <v-card>
            <pad-card-title :label="title" @close="show = false" />
            <v-card-text v-html="item.errata"></v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import PadCardTitle from '@/components/PadCardTitle'

export default {
    name: 'pad-errata-popup',
    components: { PadCardTitle },
    data: () => ({
        loading: false
    }),
    computed: {
        show: {
            get() {
                return this.$store.getters['errata/show']
            },
            set(v) {
                this.$store.commit('errata/show', { show: false })
            }
        },
        item() {
            return this.$store.getters['errata/item'] || {}
        },
        title() {
            return `Errata lot n°${this.item.nb}`
        }
    }
}
</script>
